import { memo } from 'react';
import { useNavigationHelper, useTargetBrandConfig } from 'FrontRoyalAngular';
import { useTranslation } from 'react-i18next';
import { SidebarBoxKey } from 'AdmissionsGuidance';
import { BasicDesktopBox } from '../../BasicDesktopBox';

function CompanyTuitionFundingBoxComponent({ companyName }: { companyName: string }) {
    const { loadUrl } = useNavigationHelper();
    const brandConfig = useTargetBrandConfig();
    return (
        <CompanyTuitionFundingBoxPresentation
            companyName={companyName}
            loadUrl={loadUrl}
            fundingEmailAddress={brandConfig.emailAddressForUsername('funding')}
        />
    );
}

function CompanyTuitionFundingBoxPresentation({
    companyName,
    loadUrl,
    fundingEmailAddress,
}: {
    companyName: string;
    loadUrl: ReturnType<typeof useNavigationHelper>['loadUrl'];
    fundingEmailAddress: string;
}) {
    const { t } = useTranslation('back_royal', { keyPrefix: 'companyTuitionFundingBox' });
    return (
        <BasicDesktopBox
            headerText={t('heading', { companyName })}
            buttons={[
                {
                    id: 'button_contact_us',
                    text: t('button_contact_us'),
                    onPress: () => loadUrl(`mailto:${fundingEmailAddress}`, '_blank'),
                },
            ]}
            boxKey={SidebarBoxKey.company_tuition_funding}
        >
            {t('content', { fundingEmailAddress, companyName })}
        </BasicDesktopBox>
    );
}

export const CompanyTuitionFundingBox = memo(CompanyTuitionFundingBoxComponent);
